<template>
  <div class="relative flex flex-col min-h-screen max-w-full whitespace-nowrap">
    <header class="sticky top-0 z-40 flex flex-col shadow font-bold">
      <MainMenu />
      <MainFilter />
    </header>
    <main class="flex-1 flex items-start ">
      <div class="flex-1 space-y-8">
        <Streams v-if="config.liveStreams" />
        <Channels v-if="config.channels" />
      </div>
      <Leaderboard class="self-stretch hidden sm:block" v-if="config.channels && config.leaderboard" />
    </main>
    <MainFooter />
  </div>
</template>

<script>
  import MainMenu from '@/components/MainMenu'
  import MainFilter from '@/components/MainFilter'
  import Channels from '@/components/Channels'
  import Streams from '@/components/Streams'
  import Leaderboard from '@/components/Leaderboard'
  import MainFooter from '@/components/MainFooter'
  import { config } from '@/store'

  export default {
    name: 'App',
    components: {
      MainMenu,
      MainFilter,
      Channels,
      Streams,
      Leaderboard,
      MainFooter,
    },
    setup() {
      return {
        config,
      }
    },
  }
</script>
